import { createFileRoute, redirect } from '@tanstack/react-router';

import { getStoredToken } from '@/shared/services/session.service';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: getStoredToken() ? '/home' : '/login' });
  },
});
